import { Box, CircularProgress } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

import AuthGuard from '@/components/auth-guard';
import { SceneEditForm } from '@/features/scenes';

export const Route = createFileRoute('/scenes/edit/$id')({
  component: EditScenePage,
});

function EditScenePageContent() {
  const { id: sceneId } = Route.useParams();

  return (
    <SceneEditForm sceneId={sceneId} />
  );
}

export default function EditScenePage() {
  const { t } = useTranslation();
  return (
    <AuthGuard>
      <Suspense fallback={<Box sx={{ display: 'flex', justifyContent: 'center', p: 8 }}><CircularProgress /></Box>}>
        <EditScenePageContent />
      </Suspense>
    </AuthGuard>
  );
}
